export default "/fonts/bauhs93-webfont.ttf?63f51a373f1f96e55b692fe3509b886a";